export default __webpack_public_path__ + "static/media/icon-instagram.867976de.svg";